export type ScoringLevels = {
  suspicious: number;
  malicious: number;
};

export type Level = 0 | 1 | 2 | 3;

export type RiskToleranceCardConfig = {
  level: Level;
  name: string;
  id: string;
  rl_auxiliary_analysis: { score?: ScoringLevels };
  network_references: { third_party_verdicts?: number };
  rlcs: { score?: ScoringLevels };
  joe: { confidence?: number };
  yara: { yara_forge_ruleset?: "core" | "extended" | "full" };
};

export const components = [
  "joe",
  "rlcs",
  "rl_auxiliary_analysis",
  "network_references",
  "yara"
] as const;

export type ParanoidComponent = typeof components[number];

export type CardConfig = Record<Level, ParanoidComponent[]>;

export const allComponentsByLevel: CardConfig = {
  0: [...components],
  1: [...components],
  2: [...components],
  3: [...components]
};

export type ParanoidModeConfig = {
  level: Level;
  included: ParanoidComponent[];
};
